import { createFileRoute, redirect } from "@tanstack/react-router";
import { ApiError, fetchMe, qk } from "@/lib/api";
import { DevicePage } from "./-device/DevicePage";

/** Opened from `guv login`: the terminal shows a code and this page approves it. Signs you in first if needed. */
export const Route = createFileRoute("/device")({
  validateSearch: (s: Record<string, unknown>): { code?: string } => (typeof s.code === "string" ? { code: s.code } : {}),
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData({ queryKey: qk.me(), queryFn: fetchMe });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) throw redirect({ to: "/login", search: { next: location.href } });
      throw e;
    }
  },
  staticData: { title: "Sign in a terminal" },
  component: DevicePage,
});
